/** @format */

import React from "react";

export default () => (
  <svg width="23" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11.5" cy="11.5" r="10.75" stroke="#191919" stroke-width="1.5"/>
<path d="M3.67999 19.182C3.67999 19.182 4.54684 15.632 6.58834 14.3126C9.54375 12.4025 13.3274 12.4025 16.2828 14.3126C18.3243 15.632 19.1912 19.182 19.1912 19.182" stroke="black" stroke-width="1.5"/>
<circle cx="11.73" cy="7.13001" r="3.62" stroke="#191919" stroke-width="1.5"/>
</svg>
);
